export default __webpack_public_path__ + "static/media/FDAE300B-67EF-43C7-BA9B-722FA8E75405.d2534f92.jpeg";